(() => {
  const init = (root) => {
    if (!root || !root.matches('[data-tan-automotive-journey]') || root.dataset.automotiveJourneyReady) return;
    root.dataset.automotiveJourneyReady = 'true';

    const preview = root.querySelector('[data-automotive-wall-preview]');
    const choices = Array.from(root.querySelectorAll('[data-automotive-zone-choice]'));
    const ambient = root.querySelector('[data-automotive-ambient]');
    const ambientValue = root.querySelector('[data-automotive-ambient-value]');
    const resultHeading = root.querySelector('[data-automotive-zone-heading]');
    const resultCopy = root.querySelector('[data-automotive-zone-copy]');
    const resultList = root.querySelector('[data-automotive-zone-list]');
    const frameLabel = root.querySelector('[data-automotive-frame-label]');

    const updateChoice = (choice) => {
      if (!choice || !preview) return;
      choices.forEach((item) => {
        const active = item === choice;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });

      preview.dataset.mode = choice.dataset.modeKey || 'arrival';
      if (resultHeading) resultHeading.textContent = choice.dataset.zoneTitle || '';
      if (resultCopy) resultCopy.textContent = choice.dataset.zoneNote || '';

      const payload = root.querySelector(`[data-automotive-zone-payload="${CSS.escape(choice.dataset.zoneId || '')}"]`);
      const content = payload?.content.querySelector('[data-automotive-zone-checklist]');
      if (resultList && content) resultList.innerHTML = content.innerHTML;
      if (frameLabel) frameLabel.textContent = choice.dataset.frameLabel || '';

      ['viewer', 'constraint', 'evidence'].forEach((metric) => {
        const label = root.querySelector(`[data-automotive-metric-label="${metric}"]`);
        const value = root.querySelector(`[data-automotive-metric-value="${metric}"]`);
        if (label) label.textContent = choice.dataset[`${metric}Label`] || '';
        if (value) value.textContent = choice.dataset[`${metric}Value`] || '';
      });
    };

    const updateAmbient = () => {
      if (!ambient || !preview) return;
      const strength = Number(ambient.value) / 100;
      preview.style.setProperty('--automotive-daylight', String(0.08 + strength * 0.52));
      preview.style.setProperty('--automotive-glow', String(0.72 + (1 - strength) * 0.28));
      preview.style.setProperty('--automotive-room-light', String(0.18 + strength * 0.62));
      if (ambientValue) ambientValue.textContent = `${ambient.value}%`;
    };

    choices.forEach((choice) => choice.addEventListener('click', () => updateChoice(choice)));
    ambient?.addEventListener('input', updateAmbient);
    updateAmbient();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-tan-automotive-journey]')) init(scope);
    scope.querySelectorAll?.('[data-tan-automotive-journey]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
